import { I18nService } from '@core/i18n-legacy';
import { DatasetBase } from '@core/reports-types';
import { datasetValueFormatterOptions } from '@core/reports-util';
import { valueFormatter, SupportedNumberFormat } from '@core/utils-legacy';

import { addXAxisTypeValue } from '../composables';

export const createXAxisTypeValue = () => addXAxisTypeValue({}).xAxis;

export const addXAxisDurationLabelFactory =
  (dataset: DatasetBase, i18n: I18nService) =>
  <T extends { type: 'value' }>(opts: T) => ({
    ...opts,
    axisLabel: {
      show: dataset.metric.unitType === 'duration',
      formatter: (value: number) =>
        valueFormatter(value, datasetValueFormatterOptions(dataset), i18n, {
          number: { format: SupportedNumberFormat.IntlCompact },
        }),
    },
  });
